@if (!dateOnly()) {
  <assist-timepicker
    [formControl]="timeControl"
    [min]="correctedMinTimePicker()"
    [max]="max()"
    [steps]="steps"
    [appendTo]="timePickerAppendTo()"
  />
}
<assist-datepicker [formControl]="dateControl" [min]="min()" [max]="max()" [format]="pipesService.dateFormat" />
